import React from 'react';
import '../../styles/components/AsperaColorPicker.scss';
import { Button, TextInput } from '../Carbon';
import { SketchPicker } from 'react-color';
import { language } from '../../services/LanguageService';
import { SubManager } from '../../classes/SubManager';
import { fromEvent } from 'rxjs';
import { AsperaError } from '../../classes/AsperaError';
/**
 * React Component
 *
 * The AsperaColorPicker provides a color picker text input element.
 *
 * @example
 * ```javascript
 * <AsperaColorPicker value="#FFF" helperText="Text underneath text box" />
 * ```
 */
export class AsperaColorPicker extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            openPicker: false,
        };
        this.inputRef = null;
        this.subManager = new SubManager();
        this.closePicker = () => {
            const { pickedColor } = this.state;
            const { onChange } = this.props;
            if (onChange && pickedColor) {
                onChange(this.getPickedColor(pickedColor));
            }
            this.setState({ openPicker: false, pickedColor: undefined }, () => {
                if (this.inputRef && typeof this.inputRef.focus === 'function') {
                    this.inputRef.focus();
                }
            });
        };
    }
    getPickedColor(pickedColor) {
        var _a;
        if (((_a = pickedColor.rgb) === null || _a === void 0 ? void 0 : _a.a) && pickedColor.rgb.a < 1) {
            return `rgba(${pickedColor.rgb.r}, ${pickedColor.rgb.g}, ${pickedColor.rgb.b}, ${pickedColor.rgb.a})`;
        }
        else {
            return pickedColor.hex || '';
        }
    }
    get localValue() {
        const { value } = this.props;
        const { pickedColor } = this.state;
        if (pickedColor) {
            return this.getPickedColor(pickedColor);
        }
        else {
            return value || '';
        }
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    componentDidMount() {
        this.subManager.setSubscription(fromEvent(document, 'keyup').subscribe({
            next: (event) => {
                const { openPicker } = this.state;
                if (openPicker && (event.key === 'Escape' || event.key === 'Enter')) {
                    this.closePicker();
                }
            }, error: (error) => {
                new AsperaError('AsperaColorPicker: unable to watch for keyboard events', error);
            },
        }));
    }
    render() {
        const { labelText, helperText, className, light, onChange, disabled, onKeyUp, onBlur, autoComplete, maxLength, invalid, invalidText, id, dataAuto, required, placeholder, autofillColors } = this.props;
        const { openPicker, pickedColor } = this.state;
        return (React.createElement("div", { className: `aspera-color-picker ${className ? className : ''} ${light ? 'light-mode' : ''}` },
            React.createElement(TextInput, { onKeyUp: onKeyUp, ref: (ref) => {
                    this.inputRef = ref;
                }, autoComplete: autoComplete, maxLength: maxLength, helperText: helperText, invalidText: invalidText, id: id, invalid: invalid, "data-auto": dataAuto, disabled: disabled, value: this.localValue, labelText: labelText, required: required, placeholder: placeholder, onChange: (event) => {
                    if (onChange) {
                        onChange(event.target.value || '');
                    }
                }, onBlur: onBlur }),
            React.createElement(Button, { kind: "ghost", className: "aspera-color-picker--open-picker", hasIconOnly: true, iconDescription: language.get('forms.pickColor'), tooltipAlignment: "center", tooltipPosition: "top", size: "md", onClick: () => {
                    if (openPicker) {
                        this.closePicker();
                    }
                    else {
                        this.setState({ openPicker: true });
                    }
                }, disabled: disabled },
                React.createElement("div", { style: { backgroundColor: this.localValue || undefined }, className: `button-color ${!this.localValue ? 'not-set' : ''}` })),
            openPicker && React.createElement("div", { className: "aspera-color-picker--picker" },
                React.createElement("div", { className: "aspera-color-picker--picker-backing", onClick: this.closePicker }),
                React.createElement(SketchPicker, { className: "picker-popup", color: (pickedColor === null || pickedColor === void 0 ? void 0 : pickedColor.rgb) || this.localValue, presetColors: autofillColors ? autofillColors.map(item => {
                        return {
                            color: item,
                            title: item,
                        };
                    }) : undefined, onChange: (event) => {
                        this.setState({ pickedColor: event });
                    } }))));
    }
}
